/*=========================================================================================
  File Name: moduleReport.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleReportState.js";
import mutations from "./moduleReportMutations.js";
import actions from "./moduleReportActions.js";
import getters from "./moduleReportGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
